export default __webpack_public_path__ + "static/media/schneider2.6f3d6094.png";